'use client';

import { TableHead } from '@/components/ui/table';
import { GripVertical } from 'lucide-react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import {
  getHeadClassName,
  type UnifiedColumn,
} from './history-table-column-utils';

export const SortableTableHead = ({ column, children }: { column: UnifiedColumn; children: React.ReactNode }) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    setActivatorNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id: column.id });

  const style = isDragging
    ? {
        transform: CSS.Transform.toString(transform),
        transition,
        opacity: 0.5,
      }
    : undefined;

  return (
    <TableHead className={getHeadClassName(column.id)}>
      <div
        ref={setNodeRef}
        style={style}
        className="flex min-w-0 items-center justify-center gap-0.5"
      >
        <GripVertical className="h-3 w-3 shrink-0 text-muted-foreground" />
        <div
          ref={setActivatorNodeRef}
          {...attributes}
          {...listeners}
          className="min-w-0 flex-1 cursor-pointer"
        >
          {children}
        </div>
      </div>
    </TableHead>
  );
};
